<template>
  <div>
    <b-modal
      v-model="showModal"
      ref="modal"
      centered
      size="lg"
      hide-footer
      no-close-on-backdrop
      footer-class="pt-0 border-0"
    >
      <template #modal-header="{ close }">
        <div class="d-flex justify-content-between align-items-center w-100">
          <div class="text-center flex-grow-1 text-r-20">ยกเลิกตั้งหนี้</div>
        </div>
        <button type="button" aria-label="Close" class="close" @click="close">
          ×
        </button>
      </template>
      <div class="d-flex align-items-center">
        <InputText
          placeholder="ค้นหาเอกสาร"
          v-model="filter.search"
          textFloat=""
          type="text"
          name="search_product"
          faIcon="search"
          className="my-2 w-50"
          @onEnter="(val) => getdata()"
          @onClickIcon="(val) => getdata()"
        />
        <div class="ml-4">
          {{ data.gp_barcode_name }} ({{ data.gp_barcode_percent }}%)
        </div>
      </div>

      <div class="bg-white border-red">
        <b-row>
          <b-col>
            <b-table
              responsive
              striped
              hover
              :fields="fields"
              :items="items"
              :busy="isBusy"
              show-empty
              empty-text="No matching records found"
              class="table-main oveflow-auto table-custom"
              :no-border-collapse="false"
              foot-clone
              no-footer-sorting
            >
              <template v-slot:foot()="data">
                <div
                  v-if="data.field.key == 'after_discount_price'"
                  class="text-center"
                >
                  {{ form.net_amount | numeral("0,0.00") }}
                </div>
                <div
                  v-else-if="data.field.key == 'discount_gp'"
                  class="text-center"
                >
                  {{ form.gp_discount | numeral("0,0.00") }}
                </div>
                <div
                  v-else-if="data.field.key == 'quantity'"
                  class="text-center"
                >
                  {{ form.quantity }}
                </div>
                <div v-else-if="data.field.key == 'price'" class="text-center">
                  {{ form.total_amount | numeral("0,0.00") }}
                </div>
                <span v-else>
                  <div
                    class="text-left px-2"
                    v-if="data.field.key == 'invoice_no'"
                  >
                    Total Price
                  </div>
                </span>
              </template>
              <template v-slot:cell(product_name)="data">
                <b>{{ data.item.product_name || "-" }}</b>
                <p class="text-gray-1">
                  {{ data.item.inventory_product_serial_number || "-" }}
                </p>
              </template>
              <template v-slot:cell(price)="data">
                <div>
                  {{ data.item.price | numeral("0,0.00") }}
                </div>
              </template>
              <template v-slot:cell(discount_gp)="data">
                <div>
                  {{ data.item.discount_gp | numeral("0,0.00") }}
                </div>
              </template>
              <template v-slot:cell(after_discount_price)="data">
                <div>
                  {{ data.item.after_discount_price | numeral("0,0.00") }}
                </div>
              </template>
              <template v-slot:cell(quantity)="data">
                <div>
                  {{ data.item.quantity }} /
                  {{ data.item.transaction_quantity }}
                </div>
              </template>
              <template v-slot:table-busy>
                <div class="text-center text-black my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong class="ml-2">Loading...</strong>
                </div>
              </template>
            </b-table>
          </b-col>
        </b-row>

        <div class="d-flex align-items-center justify-content-between">
          <b-button
            variant="outline-primary-color"
            class="btn-width"
            :disabled="isLoading"
            @click="hide"
          >
            ยกเลิก
          </b-button>
          <b-button
            variant="primary-color"
            class="btn-modal btn-hove"
            :disabled="isLoading || !form.detail"
            @click="createCn()"
          >
            ตกลง
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import OtherLoading from "@/components/loading/OtherLoading";
import { createConfigItem } from "@babel/core";
import { mapGetters } from "vuex";

export default {
  components: {
    OtherLoading,
  },
  props: {
    data: {
      required: false,
    },
  },
  data() {
    return {
      isLoading: false,
      showModal: false,
      filter: {
        search: "",
      },
      id: this.$route.params.id,
      form: {},

      items: [],
      isBusy: false,
      rows: 0,
      fields: [
        {
          key: "invoice_no",
          label: "เลขที่เอกสาร",
        },

        {
          key: "product_name",
          label: "สินค้า",
          tdClass: "text-left",
        },
        {
          key: "price",
          label: "ราคาตั้งยอด",
        },
        {
          key: "quantity",
          label: "จำนวน",
          tdClass: "",
        },
        {
          key: "discount_gp",
          label: "ส่วนลด GP",
          tdClass: "",
        },

        {
          key: "after_discount_price",
          label: "ราคาสุทธิ",
        },
      ],

      pageOptions: [
        { value: 5, text: "5 / page" },
        { value: 10, text: "10 / page" },
        { value: 30, text: "30 / page" },
        { value: 50, text: "50 / page" },
        { value: 100, text: "100 / page" },
      ],
      allItems: [],
    };
  },
  computed: {
    ...mapGetters({
      dateTimeFix: "getDateTimeFix",
      branchId: "getBranchId",
      isSpa: "getSpa",
      isBooth: "getBooth",
    }),
  },

  methods: {
    async show() {
      await this.getdata();
      this.showModal = true;
    },
    async getdata() {
      this.isBusy = true;
      let res = await this.axios.post(
        `${this.$baseUrl}/InvoiceConsignment/CN/TransactionList`,
        {
          ref_invoice_consignment_id: this.id,
          branch_id: this.branchId,
          search: this.filter.search,
        }
      );
      this.form = res.detail;
      this.allItems = res.detail.detail;
      this.items = res.detail.search_product;
      this.isBusy = false;
    },
    hide() {
      this.showModal = false;
    },
    async createCn() {
      await this.$store.dispatch("setMainLoading", true);
      let payload = {
        ...this.form,
        product_group_barcode_detail_id: this.data.gp_barcode_id,
        branch_id: this.branchId,
        products: this.form.detail.map((x) => ({
          ...x,
          ref_user_transaction_product_id: x.user_transaction_product_id,
        })),
      };
      let res = await this.axios.post(
        `${this.$baseUrl}/InvoiceConsignment/CN/create`,
        payload
      );
      if (res.result == 1) {
        this.successAlert(res.message);
        this.$emit("success");
        this.showModal = false;
      } else {
        this.errorAlert(res.message);
      }
      await this.$store.dispatch("setMainLoading", false);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .modal-header {
  color: #fff;
  width: 100%;
  background-color: var(--primary-color);
}

::v-deep .modal-body {
  padding: 1rem 1rem;
}

.btn-primary .modal-body {
  margin: auto;
  text-align: center;
}

::v-deep .nav-tabs li {
  border-left: 1px solid white;
  border-right: 1px solid white;
}

::v-deep .table-custom {
  position: relative;
  thead {
    position: sticky;
    top: 0;
  }
  tfoot {
    position: sticky;
  }
  tfoot {
    bottom: 0;
  }
  height: 550px;
  overflow-y: auto;
}

.no-data-item {
  min-height: 88px;
  display: flex;
  justify-content: center;
  font-size: 14px;
  color: #bdbdbd;
  align-items: center;
  background-color: #fff;
  padding: 0.5rem;
  margin: 0.5rem;
}
</style>
